// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UvP8","importantInfo":"styles_importantInfo__1_0Zj"};